import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NzMessageService } from 'ng-zorro-antd/message';
import { SettingsService } from 'src/app/core/services/settings.service';
import { MessagePack } from '../../model';
import { RtcService } from '../../rtc.service';

@Component({
  selector: 'app-live-element',
  templateUrl: './live-element.component.html',
  styleUrls: ['./live-element.component.css']
})
export class LiveElementComponent implements OnInit {

  @Input() message: MessagePack = null;

  @Output() joinLive = new EventEmitter<MessagePack>();

  constructor(public rtcService: RtcService) {

  }

  ngOnInit(): void {

  }


  gotoLive() {
    this.joinLive.emit(this.message);
  }
}
